import React from "react";
import { Segment, Divider } from "semantic-ui-react";
import { SemanticContainer, SemanticSegment } from "./styled";

import Back from "../Back";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import CreateVacancyForm from "../CreateVacancyForm";

const VacancyCreate = (props) => {
  return (
    <div
      style={{
        padding: "0 0 0px 250px",
      }}
    >
      <AdminMenu />
      <SemanticContainer>
        <Back actualPage={"Criar"} />
        <h2>Criar Nova Vaga</h2>
        <Divider />
        <Segment>
          <CreateVacancyForm />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment>
          Grupo Voitto <i class="copyright outline icon"></i>
          {new Date().getFullYear()}
        </SemanticSegment>
      </SemanticContainer>
    </div>
  );
};

export default VacancyCreate;
